import { render } from "./ReferralEarningsView.vue?vue&type=template&id=c4e27f06&scoped=true"
import script from "./ReferralEarningsView.vue?vue&type=script&lang=js"
export * from "./ReferralEarningsView.vue?vue&type=script&lang=js"

import "./ReferralEarningsView.vue?vue&type=style&index=0&id=c4e27f06&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e27f06"]])

export default __exports__